// Wrappers de la sección GAME. Reusan las páginas genéricas pasando
// `clienteCodigo="GAME"` para filtrar y ocultar la columna Cliente.
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/useEntity';
import { ProductosList } from '../productos/ProductosList';
import { HistoricoVentas } from '../productos/HistoricoVentas';
import { NuevosProductosList } from '../nuevos-productos/NuevosProductosList';
import { PedidosClienteList } from '../pedidos-cliente/PedidosClienteList';
import { CotizacionesList } from './CotizacionesList';
import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';

// Re-export de páginas específicas de GAME para que App.tsx pueda
// importar todo desde aquí.
export { GameParametros } from './GameParametros';
export { GameBolsaProvisionamiento } from './GameBolsaProvisionamiento';
export { GameCalculadora } from './GameCalculadora';

const CLIENTE = 'GAME';
const HUMAN = 'GAME';

export function GameDashboard() {
  return (
    <div>
      <PageHeader
        title={`Dashboard ${HUMAN}`}
        subtitle="Resumen operativo del cliente GAME."
      />
      <Card>
        <p className="text-sm text-slate-600">
          Pendiente de definir. Mostraremos aquí los KPIs operativos de
          GAME: ventas mes en curso vs. mes anterior, productos con stock
          bajo, nuevos productos en marcha, pedidos en tránsito, evolución
          semanal del stock.
        </p>
      </Card>
    </div>
  );
}

export function GameProductos() {
  return <ProductosList clienteCodigo={CLIENTE} title="Productos GAME" subtitle="Catálogo consolidado de productos comercializados a GAME." />;
}

export function GameHistoricoVentas() {
  return (
    <HistoricoVentas
      clienteCodigo={CLIENTE}
      title="Histórico Ventas GAME"
      subtitle="Ventas semanales por producto. Cada columna es la fecha del fichero importado; por defecto, las últimas 8 semanas con datos."
    />
  );
}

export function GameNuevosProductos() {
  return <NuevosProductosList clienteCodigo={CLIENTE} title="Proyectos / Ideas — GAME" subtitle="Briefings de búsqueda para incorporar nuevos productos al catálogo de GAME." />;
}

export function GamePedidos() {
  // El listado de pedidos de cliente necesita cliente_id para crear
  // pedidos nuevos. Lo resolvemos desde el cliente por código GAME.
  const clientes = useQuery({
    queryKey: ['list', '/admin/clientes'],
    queryFn: () => api.get<{ data: Array<{ id: string; codigo: string }> }>('/admin/clientes'),
  });
  const clienteId = clientes.data?.data?.find((c) => c.codigo === CLIENTE)?.id ?? null;
  return (
    <PedidosClienteList
      clienteCodigo={CLIENTE}
      clienteId={clienteId}
      title="Pedidos GAME"
      subtitle="Pedidos del cliente. Cada línea es un producto cotizado; al pasar el pedido a Aceptado se generan los pedidos a proveedor."
    />
  );
}

export function GameCotizaciones() {
  return (
    <CotizacionesList
      clienteCodigo={CLIENTE}
      title="Cotizaciones GAME"
      calcRoute="/game/calculadora"
    />
  );
}

// GameCalculadora vive en GameCalculadora.tsx (re-export arriba).
// GameParametros vive en GameParametros.tsx (página custom no AdminCrudPage).
// GameBolsaProvisionamiento vive en GameBolsaProvisionamiento.tsx.
